// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3gCmP","footer":"ReportModalFilter_footer__10ul8"};